import { render } from "./TabsContentItem.vue?vue&type=template&id=ef4d2c86"
import script from "./TabsContentItem.vue?vue&type=script&lang=js"
export * from "./TabsContentItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nikita/Documents/works/novosel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__